import type { LandingPageContent } from '../types'

export const FOTOVOLTAICA_BOMBA_DE_CALOR: LandingPageContent = {
  slug: 'fotovoltaica-bomba-de-calor',
  lang: 'es',
  topicId: 'photovoltaik-waermepumpe',
  title: 'Fotovoltaica y bomba de calor: compare presupuestos de forma independiente',
  metaDescription:
    'Planifique juntos la bomba de calor y la instalación solar: compare gratis presupuestos de ' +
    'empresas verificadas, sin lluvia de llamadas - para ambos proyectos por separado o juntos.',
  keywords: [
    'fotovoltaica bomba de calor',
    'placas solares para bomba de calor',
    'bomba de calor fotovoltaica',
    'consumo eléctrico bomba de calor',
    'fotovoltaica wallbox bomba de calor',
  ],
  eyebrow: 'Bomba de calor + fotovoltaica',
  h1: 'Fotovoltaica y bomba de calor: compare presupuestos de forma independiente',
  intro:
    'Una bomba de calor es, con diferencia, el mayor consumidor eléctrico de una vivienda - y una ' +
    'instalación fotovoltaica le proporciona precisamente esa electricidad de forma económica. En ' +
    'Roofora puede solicitar ambos proyectos como peticiones independientes y anónimas, y comparar ' +
    'presupuestos de empresas instaladoras verificadas - gratis, sin lluvia de llamadas, con el ' +
    'contacto liberado solo tras su autorización.',
  sections: [
    { type: 'heading', text: 'Por qué fotovoltaica y bomba de calor van de la mano' },
    {
      type: 'paragraph',
      text:
        'Una bomba de calor convierte electricidad en varias veces esa cantidad de calor - que esa ' +
        'electricidad venga de la red o de su propio tejado no cambia la potencia calorífica, pero sí ' +
        'notablemente el coste por kilovatio-hora de calor. Si la bomba de calor funciona ' +
        '(automática o manualmente) preferentemente cuando la instalación fotovoltaica genera mucha ' +
        'electricidad, la parte de autoconsumo aumenta claramente, en lugar de verter el excedente de ' +
        'mediodía a la red por poco dinero y recomprar electricidad cara por la noche.',
    },
    { type: 'heading', text: 'Dos solicitudes independientes, una planificación conjunta' },
    {
      type: 'list',
      items: [
        'Fotovoltaica como solicitud propia: sistema completo, solo montaje en tejado o solo instalación eléctrica',
        'Bomba de calor como tipo de solicitud propio, independientemente de si ya tiene una instalación fotovoltaica',
        'Ambas solicitudes anónimas - las empresas instaladoras presentan presupuestos sin compromiso sin que usted revele datos de contacto',
        'El contacto solo se produce cuando usted autoriza individualmente a una empresa concreta - sin autorización colectiva, sin lluvia de llamadas',
      ],
    },
    { type: 'heading', text: 'Qué tener en cuenta al combinar ambos sistemas' },
    {
      type: 'list',
      items: [
        'Dimensione la fotovoltaica según el consumo real: el consumo anual incluyendo la bomba de calor debería entrar en el cálculo del tamaño de la instalación, no solo el consumo doméstico previo',
        'Revise el depósito de inercia: un depósito suficientemente grande permite almacenar el excedente fotovoltaico en forma de calor',
        'Tenga en cuenta la temperatura de impulsión: la calefacción por suelo radiante permite temperaturas más bajas y por tanto una bomba de calor más eficiente que los radiadores clásicos',
        'Planifique el orden: si la instalación fotovoltaica se dimensiona sin pensar en una futura bomba de calor, después suele quedarse pequeña para el nuevo consumo',
      ],
    },
  ],
  faq: [
    {
      q: '¿Tengo que solicitar fotovoltaica y bomba de calor juntas en Roofora?',
      a: 'No - ambos son tipos de solicitud independientes que puede realizar por separado. Para un tamaño de instalación realista, sí conviene indicar el consumo adicional de la bomba de calor en la solicitud fotovoltaica.',
    },
    {
      q: '¿Cuánto aumenta mi consumo eléctrico una bomba de calor?',
      a: 'Depende mucho del edificio, la carga térmica y la eficiencia de la bomba de calor - dar una cifra genérica no sería serio. Las empresas instaladoras pueden estimarlo de forma realista según los datos de su calefacción actual.',
    },
    {
      q: '¿Puedo ver un valor orientativo de coste de mi instalación fotovoltaica antes de solicitar?',
      a: 'Sí - en la calculadora de precios obtiene un valor orientativo solo para la instalación fotovoltaica, basado en presupuestos reales. La calculadora no incluye un recargo específico por bomba de calor, ya que no existe una base de datos fiable para ello.',
    },
    {
      q: '¿Y si solo quiero solicitar la bomba de calor, sin fotovoltaica?',
      a: 'Sin problema - el tipo de solicitud bomba de calor se puede usar de forma independiente de una instalación fotovoltaica.',
    },
  ],
  primaryCta: { label: 'Solicitar bomba de calor', action: 'customer' },
  secondaryCta: { label: 'Cómo calculamos el precio orientativo', action: 'link', href: '/como-calculamos-el-precio' },
  relatedLinks: [
    { label: '¿Cuánto cuesta una instalación solar?', href: '/coste-instalacion-fotovoltaica' },
    { label: 'Cómo funciona la comparación de presupuestos', href: '/comparar-presupuestos-fotovoltaicos' },
  ],
}
